import { useQuery } from '@tanstack/react-query';
import { FirebaseCallable, functions } from '@util/firebase';
import { TrackPackageResponse } from '@util/firestore/shipengine';
import { httpsCallable } from 'firebase/functions';

export const useTrackingInfo = (tracking_number?: string, carrier?: string) => {
  async function getTrackingInfo(tracking_number: string, carrier: string) {
    const { data } = await httpsCallable<
      { carrier: string; trackingNo: string },
      TrackPackageResponse
    >(
      functions,
      FirebaseCallable.trackPackage
    )({ carrier, trackingNo: tracking_number });
    return data;
  }
  const data = useQuery({
    queryKey: ['trackingInfo', tracking_number],
    queryFn: async () => {
      if (!tracking_number || !carrier)
        throw new Error('Missing tracking number or carrier');
      return await getTrackingInfo(tracking_number, carrier);
    },
    enabled: !!tracking_number && !!carrier,
  });

  return { data, getTrackingInfo };
};
